import Client from 'shopify-buy';

export const client = Client.buildClient({
  domain: 'toothyz1.myshopify.com',
  storefrontAccessToken: 'f4bb8304526ecb11175b9eeee08e4c26'
});